// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__lB3dg","title":"Item_title__FRXfj","content":"Item_content__D0QVD","date":"Item_date__dHQJG","image":"Item_image__zmLBQ","arrow":"Item_arrow__kf966"};